module.exports = __webpack_public_path__ + "static/img/che06.d646d95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/che06.png
// module id = jW4+
// module chunks = 1